<template>
  <button
    type="button"
    :disabled="disabled"
    :class="[
      'flex items-center w-full gap-3 px-4 py-3 text-left transition-colors rounded-lg cursor-pointer',
      destructive
        ? 'text-red-400 hover:bg-white/10'
        : 'text-white hover:bg-white/10',
      disabled && 'opacity-40 cursor-not-allowed'
    ]"
    @click="handleClick">
    <fa-icon
      v-if="icon"
      :icon="icon"
      :class="['w-5', destructive ? 'text-red-400' : 'text-gray-400']" />
    <span class="font-medium">{{ label }}</span>
  </button>
</template>

<script setup>
const props = defineProps({
  label: {
    type: String,
    required: true
  },
  icon: {
    type: [String, Array],
    default: null
  },
  destructive: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['click'])

const handleClick = () => {
  if (!props.disabled) {
    emit('click')
  }
}
</script>
